import { useMemo } from "react";
import { DEFAULT_VARIANT_ELEMENTS } from "../constants/variants";
import { getHtmlElementFromHtmlTagProp } from "../logic";
var useTypographyElementFromTagProp = function useTypographyElementFromTagProp(htmlTag, variant) {
  var renderedComponent = useMemo(function () {
    return getHtmlElementFromHtmlTagProp(DEFAULT_VARIANT_ELEMENTS, htmlTag, variant);
  }, [htmlTag, variant]);
  return renderedComponent;
};
export default useTypographyElementFromTagProp;